// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cbef4d1d","545":"d5c208df","787":"4832c2f1","845":"471aef80"}[chunkId] + ".chunk.js";
};